import { red } from "utils/constants/colors";

const theme = {
  primary: red,
};

export default theme;
